import s from './NavigationFooter.module.css';
import type { FC, ReactNode } from 'react';
import { clsx } from 'clsx';
import { Flex } from '@repo/ui/Flex';

type NavigationFooter = FC<{
  leftChildren: ReactNode;
  rightChildren: ReactNode;
  hide?: boolean;
  isFixed?: boolean;
}>;

export const NavigationFooter: NavigationFooter = ({
  leftChildren,
  rightChildren,
  hide = false,
  isFixed,
}) => {
  if (hide) return null;
  const centered = !leftChildren || !rightChildren;

  return (
    <div className={clsx(s.position, s.mobile, isFixed && s.fixed)}>
      <footer
        className={clsx({
          [s.container]: true,
          [s.fixed]: isFixed,
        })}
      >
        <Flex
          direction="row"
          gap="g-48"
          justifyContent="center"
          alignItems="center"
        >
          <div className={s.centerGroup}>
            {leftChildren && (
              <div
                className={clsx({
                  [s.leftChildren]: true,
                  [s.centered]: centered,
                })}
              >
                {leftChildren}
              </div>
            )}
            {rightChildren && (
              <div
                className={clsx({
                  [s.rightChildren]: true,
                  [s.centered]: centered,
                })}
              >
                {rightChildren}
              </div>
            )}
          </div>
        </Flex>
      </footer>
    </div>
  );
};
